import React from 'react'

export default function RegisterButtons() {
  return (
    <> 
      <div className="registers-container">        
        <a href="https://spiredatasets.ee.iisc.ac.in/syspincorpus" className="regist-btn-outline" target='_blank' rel='noreferrer '>
          Download SYSPIN Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/englishttscorpus" className="regist-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_1.0 Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/gujaratittscorpus" className="regist-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_2.0 Dataset
        </a>
      </div>
      <div className="registers-container">
        <a href="/register" className="register-btn-outline" target='_blank' rel='noreferrer '>
          Register Now
        </a>
      </div>
    </>
  )
}
